var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512 365.315a32 32 0 0 1-32 32H109.255l54.658 54.658a32 32 0 0 1-45.255 45.256L9.373 387.943a32 32 0 0 1 0-45.255L118.658 233.4a32 32 0 1 1 45.255 45.256l-54.658 54.657H480a32 32 0 0 1 32 32.002zM393.342 14.771a32 32 0 0 0-45.255 45.256l54.658 54.658H32a32 32 0 0 0 0 64h370.745l-54.658 54.657a32 32 0 0 0 45.255 45.258l109.285-109.287a32 32 0 0 0 0-45.256z",
    fill: "#3c0000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.e38077f881d288c64f812c9e2838ae8c.svg";
export { ForwardRef as ReactComponent };